module.exports = "<loading-screen model=loading.active messages=loading.messageList></loading-screen> <ng-transclude></ng-transclude> ";